import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import MarketingNavItem from './MarketingNavItem';
import { useLocation } from 'react-use';
import routes from '@gik/core/routes';

export interface IMarketingNavItem {
  pathname: string;
  label: React.ReactNode;
}

const items: IMarketingNavItem[] = [
  {
    pathname: routes.features,
    label: 'Features',
  },
  {
    pathname: routes.howItWork,
    label: 'How Give InKind Works',
  },
  {
    pathname: routes.competitors,
    label: 'Compare us to...',
  },
  {
    pathname: routes.benefits,
    label: 'The Benefits of an InKind Page',
  },
  {
    pathname: routes.tipsAndSamplePages,
    label: 'Tips & Sample Pages',
  },
  {
    pathname: routes.commonQuestions,
    label: 'Common Questions',
  },
];

export default function MarketingNav(): React.ReactElement {
  const location = useLocation();
  const bem = bemBlock('marketing-nav');

  return (
    <ul className={bem()}>
      {items
        .filter(item => !item.pathname.includes(location.pathname))
        .map((item, index) => {
          return (
            <MarketingNavItem href={item.pathname} key={index}>
              {item.label}
            </MarketingNavItem>
          );
        })}
    </ul>
  );
}
